import React from "react";
import { DocProps, DocMap } from "../../Language";
import { AutogiroTermsSV as SV } from "./AutogiroTermsSV";
import "../../Documents.css";

const docsMap: DocMap = { SV };

export const AutogiroTerms: React.FC<DocProps> = ({ language }) =>
  React.createElement(docsMap[language], null);
